import axios from 'axios';
import verifyDatas from '../views/verifyDatas';
import url from './Url';

class logger extends url {
    constructor() { super() }

    passwordUpdate = (email, password) => {
        if (verifyDatas.isValid(email) && verifyDatas.isValid(password)) {
            const data = { email, password }

            return axios.put(`${this.url()}/user-redefinization-password-out-plataform`, data)
                .then(response => {
                    return { message: response.data }
                })
                .catch(err => {
                    const responseError = {
                        status: err.response.status,
                        message: err.response.data,
                    }
                    return responseError
                })
        } else {
            return console.log("Insira um valor Válido")
        }
    }

    Login = (email, password) => {
        if (verifyDatas.isValid(email) && verifyDatas.isValid(password)) {
            const data = { email, password }

            return axios.post(`${this.url()}/user-login`, data)
                .then(userLogger => {
                    const token = userLogger.data.token
                    localStorage.setItem("token", token)
                    localStorage.setItem("user", JSON.stringify(userLogger.data.user))

                    const response = {
                        status: userLogger.status,
                        message: userLogger.data.message,
                        user: userLogger.data.user
                    }
                    return response
                })
                .catch(err => {
                    const responseError = {
                        status: err.response.status,
                        message: err.response.data
                    }
                    return responseError
                })
        } else {
            return console.log("Insira um valor Válido")
        }
    }
}

export default logger;